import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FixedOptionSelectDashboard, GroupOptionsSelectDashboard, OptionsSelectDashboard, SelectDashboard } from '../../../../../utils/models/input.interface';
import { RequestAttribute, RequestParams } from '../../../../../utils/models/http.interface';
import { HttpService } from '../../../../service/http/http.service';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import moment from 'moment';

@Component({
  selector: 'select-dashboard-induxtry',
  templateUrl: './select-dashboard.component.html',
  styleUrls: ['./select-dashboard.component.scss'],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'custom-overlayer-select-dashboard' }
    }
  ]
})
export class SelectDashboardComponent implements OnInit, OnChanges {
  @Input() selectInput: SelectDashboard;
  @Input() fixedOption?: FixedOptionSelectDashboard;
  @Input() attributes: RequestAttribute[] = [];
  @Input() searchParams: string = 'search';
  @Input() searchValue: string;
  @Input() requestParams: RequestParams = {
    sort: '',
    order: '',
    page: 1,
    limit: 30,
  };

  @Output() selectedOption: EventEmitter<any> = new EventEmitter<any>();
  @Output() clickFooterButton: EventEmitter<string> = new EventEmitter<string>();

  optionsSelect: OptionsSelectDashboard[] | GroupOptionsSelectDashboard[] = [];
  finallyScroll = false;
  loading = false;
  widthSelect = '62px';
  valueOptions: OptionsSelectDashboard[] = [];
  lastSearch = '';

  private readonly _onDestroy = new Subject<void>();
  public formAux: FormControl = new FormControl();

  constructor(
    private readonly httpService: HttpService,
    private readonly elRef: ElementRef<HTMLElement>,
  ) { }

  ngOnInit(): void {
    if (this.selectInput?.externalOptions?.length > 0) {
      this.optionsSelect = this.selectInput.externalOptions;
      this.fixOptions();
      this.changeWidthSelect();
    } else if (this.selectInput?.endpoint && this.selectInput?.configApi) {
      this.getDataSelect(true);
    }
    this.formAux.valueChanges.pipe(
      takeUntil(this._onDestroy),
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe((subs) => {
      this.lastSearch = subs;
      this.adjustSearchAttribute(subs);
    });
  }

  fixOptions(): void {
    const opt: any = this.optionsSelect[0];
    if (this.fixedOption && opt && !opt?.group) {
      const opts: any = this.optionsSelect;
      const indexFixed = opts.findIndex(res => res.value === this.fixedOption.value);
      if (indexFixed !== -1) {
        this.optionsSelect = [opts[indexFixed], ...opts.filter(res => res.value !== this.fixedOption.value)]
      }
    }
  }

  getValSuffix(value: any): string {
    if (this.selectInput?.suffixFormat && this.selectInput.suffixFormat === 'date') {
      return moment.parseZone(value).format('DD/MM/YYYY') || value;
    }
    return value;
  }

  ngOnChanges(changes): void {
    if (
      this.searchValue !== undefined &&
      this.searchValue !== null &&
      this.searchValue !== ''
    ) {
      this.formAux.setValue(this.searchValue);
      this.adjustSearchAttribute(this.searchValue);
    }
  }

  openedSelectDashboard(event): void {
    const fatherElement: any = this.elRef.nativeElement.parentNode.parentNode;
    fatherElement.classList.toggle('focus-open-select');
    const panelClass = '.panel-select-dashboard', panelElement = document.querySelector(panelClass) as HTMLElement;
    if (panelElement) {
      if (this.selectInput?.widthPanel) {
        panelElement.style.maxWidth = `${this.selectInput.widthPanel}px`;
        panelElement.style.width = `${this.selectInput.widthPanel}px`;
        const valueLeft = `-${(this.selectInput.widthPanel - this.elRef.nativeElement.offsetWidth) - 5}px`;
        panelElement.style.left = (this.elRef.nativeElement.offsetWidth < this.selectInput.widthPanel ? valueLeft : '-0.375rem');
      } else {
        panelElement.style.maxWidth = 'calc(100% + 32px)';
        panelElement.style.width = 'calc(100% + 32px)';
        panelElement.style.left = `-0.375rem`
      }
    }
    if (event && this.selectInput?.alwaysUpdate) {
      this.requestParams.page = 1;
      this.finallyScroll = true;
      this.optionsSelect = [];
      this.getDataSelect();
    }
  }

  adjustSearchAttribute(valueSearch): void {
    this.requestParams.page = 1;
    this.finallyScroll = true;
    this.optionsSelect = [];
    const findIndexSearchAttr = this.attributes.findIndex(res => res.param === this.searchParams);
    if (!valueSearch && valueSearch !== 0 && findIndexSearchAttr !== -1) {
      this.attributes.splice(findIndexSearchAttr,1);
    } else {
      if (findIndexSearchAttr !== -1) {
        this.attributes[findIndexSearchAttr].value = valueSearch;
      } else {
        this.attributes.push({ param: this.searchParams, value: valueSearch });
      }
    }
    this.getDataSelect(false, valueSearch);
  }

  getDataSelect(initial = false, search = ''): void {
    this.loading = true;
    this.httpService.genericGetSelectDashboard<any>(
      this.selectInput?.configApi,
      this.selectInput?.endpoint,
      this.requestParams,
      this.attributes
    )
    .subscribe((object: any[] | any) => {
      if (
        search === '' ||
        (search !== '' && this.lastSearch === search)
      ) {
        this.optionsSelect = this.optionsSelect.length > 0 ? [...this.optionsSelect, ...(object?.rows || [])] : this.optionsSelect = object?.rows;
        this.fixOptions();
        this.finallyScroll = object?.rows?.length > 0 ? false : true;
      }
      this.loading = false;
      if (initial) {
        this.changeWidthSelect();
      }
    }, error => {
      this.loading = false;
      if (initial) {
        this.changeWidthSelect();
      }
    });
  }

  handleInfiniteScroll(): void {
    if (!this.loading && this.selectInput.hasInfiniteScroll && !this.finallyScroll) {
      this.requestParams.page++;
      this.getDataSelect();
    }
  }

  verifyOptionsValueSelected(opts: any, value): string {
    const verifyGroup: any = opts[0];
    if (verifyGroup){
      if (verifyGroup.group) {
        let rValue = null, closeForeach = false;
        opts.forEach(group => {
          if (closeForeach) return;
          group.options.forEach(item => {
            if (item.value === value) {
              rValue = item.viewValue;
              closeForeach = true;
              return;
            }
          });
        });
        return rValue;
      } else {
        const nowOption: any = opts.findIndex((res: any) => res.value === value);
        if (nowOption !== -1) {
          const nowValue: any = opts[nowOption];
          return nowValue.viewValue;
        }
      }
    }
    return null;
  }

  returnValueSelect(value): string {
    let firstVal = this.verifyOptionsValueSelected(this.optionsSelect, value);
    if (firstVal === null) {
      firstVal = this.verifyOptionsValueSelected(this.valueOptions, value);
    } else {
      const val = this.valueOptions.find(res => res.value === value);
      if (!val) {
        this.valueOptions.push({
          value: value,
          viewValue: firstVal
        })
      }
    }
    return firstVal;
  }

  handleSelectionChange(): void {
    this.selectedOption.emit(this.selectInput.value);
    this.addValueOptions(this.selectInput.value);
    this.changeWidthSelect();
  }

  addValueOptions(valueOpt): void {
    const verifyGroupVO: any = this.optionsSelect[0];
    let valOption = null;
    if (verifyGroupVO){
      if (verifyGroupVO.group) {
        let voCloseForeach = false;
        this.optionsSelect.forEach(group => {
          if (voCloseForeach) return;
          group.options.forEach(item => {
            if (item.value === valueOpt) {
              valOption = item;
              voCloseForeach = true;
              return;
            }
          });
        });
      } else {
        const nowOption: any = this.optionsSelect.findIndex((res: any) => res.value === valueOpt);
        if (nowOption !== -1) {
          const nowValue: any = this.optionsSelect[nowOption];
          valOption = nowValue;
        }
      }
    }
    if (valOption) this.valueOptions.push(valOption);
  }

  changeWidthSelect(): void {
    this.widthSelect = '62px';
    setTimeout(() => {
      const valueElement = this.elRef.nativeElement.querySelector('.trigger-select-dashboard');
      if (valueElement) {
        this.widthSelect = `${(valueElement.clientWidth < 300 ? valueElement.clientWidth : 300) + 50}px`;
      }
    }, 25);
  }

  handleClickButtonsSelect(event): void {
    this.clickFooterButton.emit(event[1] || '');
  }
}
